import { TextModel } from '../primitive/text.model';
import { CompositeModel } from '../complex/composite.model';

export class MaterialInventoryModel extends CompositeModel {
    public materialInventoryList: CseStockModel[] = [];
    public materialNumber: TextModel;
    public materialDescription: TextModel;
    public constructor(materialInventoryList: CseStockModel[]) {
        super('MaterialInventoryModel');
        this.materialNumber = <TextModel>this.set(new TextModel('MaterialNo'));
        this.materialDescription = <TextModel>this.set(new TextModel('MaterialDesc'));
        this.materialInventoryList = materialInventoryList;
    }
}

export class CseStockModel {
    public readonly materialNumber: string;
    public readonly description: string;
    public readonly batchNumber: string;
    public readonly storageLocation: string;
    public readonly storageLocationDesc: string;
    public readonly quantity: number;
    public readonly notificationNumber: string;
    public readonly poNumber: string;
    public constructor(cseStockSet: ODataCseStockAvailabilityModel) {
        this.materialNumber = cseStockSet.Material;
        this.description = cseStockSet.MaterialDesc;
        this.batchNumber = cseStockSet.BatchNumber;
        this.storageLocation = cseStockSet.StorageLoc;
        this.storageLocationDesc = cseStockSet.StorageLocDesc;
        this.quantity = parseInt(cseStockSet.Quantity, 10);
        this.notificationNumber = cseStockSet.NotificationNo;
        this.poNumber = cseStockSet.PONumber;
    }
}

export interface ODataCseStockResponse {
    results: [ODataCseStockModel];
}

export interface ODataCseStockModel {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    FrontId: string;
    Material: string;
    Plant: string;
    SalesOrg: string;
    StorageLoc: string;
    CSEStockAvailability: { results: ODataCseStockAvailabilityModel[] };
}

export interface ODataCseStockAvailabilityModel {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    BatchNumber: string;
    CustomerCurrency: string;
    CustomerPrice: string;
    DangerousGoodsIndicator: string;
    ExtUnit: string;
    HazardousMaterial: string;
    ItemNumber: string;
    LocalScrapReturnC: string;
    LocalScrapReturnD: string;
    LocalScrapReturnV: string;
    LocalScrapReturnX: string;
    LsCrChangeable: string;
    Material: string;
    MaterialDesc: string;
    NotificationNo: string;
    PONumber: string;
    Quantity: string;
    SerialPIndicat: string;
    StorageLoc: string;
    StorageLocDesc: string;
}
